// extracted by mini-css-extract-plugin
export default {"body":"logsPage_body__Y5fsh","flexRow":"logsPage_flexRow__QawIS","logHeader":"logsPage_logHeader__07J02","logsContainer":"logsPage_logsContainer__jAIho"};